import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { connect } from 'react-redux';

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import ConsoleLayout from "layouts/console";
import { useLocation } from "react-router-dom";
import CrudHandler from "components/crudhandler";
import PrivateLayout from "layouts/private";
import MyPayslip from "views/private/my-payslip/index";
import FinanceView from "views/private/my-payslip/financeview";
import PreviewCOE from "views/private/final-pay/previewcoe";
import Error404 from "views/error/error404";
import { theme } from 'theme';
import { ConfigProvider } from 'antd';
import CareersLayout from "layouts/careers";

const App = ({auth, pageTitle}) => {

	const location = useLocation();
  	const targetLocation = location.pathname;  	

  	return (
		<ConfigProvider theme={theme}>
	  	<CrudHandler />
	    <Routes>
	      	{auth.isLoggedIn && <Route path="/auth/sign-in" element={<Navigate to="/console" />} />}      	
	        {auth.isLoggedIn ? (
			<>
	          	<Route path="/" element={<Navigate to={targetLocation !== '/' ? targetLocation : '/console/dashboard'} />} />
	          	<Route path="console/*" element={<ConsoleLayout />} />
	          	<Route path="admin/*" element={<AdminLayout />} />
	          	<Route path="rtl/*" element={<RtlLayout />} />
				<Route path="careers/*" element={<CareersLayout />}></Route>
	          	<Route path="private/*" element={<PrivateLayout />}>
	        		<Route path="view-payslip/:empCode/:payrollId/:encodedHash/:encodedPin" element={<FinanceView />} />
					<Route path="final-pay/coe/:empId" element={<PreviewCOE />} />
        	  	</Route>
        	</>
	      	) : (
			<>
			<Route path="careers/*" element={<CareersLayout />}></Route>
			<Route path="/*" element={<Navigate to="/auth/sign-in" replace />}/>
			</>
	      	)}
	        <Route path="auth/*" element={<AuthLayout />} />
	        <Route path="private/*" element={<PrivateLayout />}>
	        	<Route path="my-payslip/:empCode/:payrollId/:hash" element={<MyPayslip />} />
	        	<Route path="*" element={<Error404 />} />
	        </Route>
	    </Routes>
      </ConfigProvider>
  	);
};

const mapStateToProps = (state) => ({
	auth: state.auth,	
  });
  
const mapDispatchToProps = (dispatch) => ({

});
  
  
export default connect(mapStateToProps, mapDispatchToProps)(App);
